<template>
	<div class="box_inner">
		<ul class="header_tabs" v-show="tab !== 'Register'">
			<li
				class="item"
				:class="{ active: tab === 'pwdLogin' }"
				@click="changeTab('pwdLogin')"
			>
				{{$t('user.login.pwdlogin')}}
			</li>
			<!-- <li
				class="item"
				:class="{ active: tab === 'verifyCodeLogin' }"
				@click="changeTab('verifyCodeLogin')"
			>
				{{$t('user.login.codelogin')}}
			</li> -->
		</ul>
		<div class="text-center tab_content">
			<components :is="tab" @change="changeTab"></components>
			<div class="between_line">
				<router-link class="btn"  :to="{name:'forget'}">{{$t('user.login.forgetpwd')}}</router-link>
				<div>
					{{$t('user.login.noaccount')}} <router-link class="btn" :to="{name:'register'}">{{$t('user.login.register')}}</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { VerifyCodeLogin, PwdLogin } from "../components";
export default {
	name: "login",
	data() {
		return {
			tab: "pwdLogin",
		};
	},
	methods: {
		changeTab(tab) {
			this.tab = tab;
		},
	},
	components: {
		VerifyCodeLogin,
		PwdLogin,
	},
};
</script>
<style lang="sass" scoped>
.header_tabs
	display: flex
	align-items: baseline
	.item
		font-size: 1.6rem
		font-weight: 500
		color: rgba(51, 51, 51, .8)
		line-height: 3.8rem
		cursor: pointer
		user-select: none
		&:not(:last-child)
			margin-right: 3.5rem
		&.active
			font-size: 2.7rem
			color: rgba(51, 51, 51, 1)
	.tab_content
		padding-top: 3.7rem
.between_line
	display: flex
	justify-content: space-between
	margin-top: .6rem
	.btn
		cursor: pointer
</style>
